<script setup>
import { ref, computed, nextTick, watch } from 'vue'
import GallerySlider from '@/components/GallerySlider.vue'
import { useSlideshowStore } from '@/stores/gallery/slideshow'

const slideshowStore = useSlideshowStore()

// State -----------------------------------------
const filterPlace = ref(1)
const filterCategory = ref(1)

// Getters ---------------------------------------
const activedItem = computed(() => slideshowStore.activedItem)

// Methods ---------------------------------------
function isShowSlider(place, category) {
  if (activedItem.value !== undefined) {
    return activedItem.value.place == place && activedItem.value.category == category
  }
  return false
}

// Events ----------------------------------------

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <div class="gallery-slideshow">
    <!--------------------------->
    <transition name="fade-slideshow" mode="out-in" appear>
      <GallerySlider v-if="isShowSlider(1, 1)" :place="1" :category="1" />
      <GallerySlider v-else-if="isShowSlider(1, 2)" :place="1" :category="2" />
      <GallerySlider v-else-if="isShowSlider(1, 3)" :place="1" :category="3" />
      <GallerySlider v-else-if="isShowSlider(1, 4)" :place="1" :category="4" />
      <GallerySlider v-else-if="isShowSlider(1, 5)" :place="1" :category="5" />
      <GallerySlider v-else-if="isShowSlider(2, 1)" :place="2" :category="1" />
      <GallerySlider v-else-if="isShowSlider(2, 2)" :place="2" :category="2" />
      <GallerySlider v-else-if="isShowSlider(2, 3)" :place="2" :category="3" />
      <GallerySlider v-else-if="isShowSlider(2, 4)" :place="2" :category="4" />
      <GallerySlider v-else-if="isShowSlider(2, 5)" :place="2" :category="5" />
    </transition>
    <!--------------------------->
  </div>
</template>

<style scoped>
/* ------------------------ */
.fade-slideshow-enter-active,
.fade-slideshow-leave-active {
  transition: opacity 0.3s ease;
}
.fade-slideshow-enter-from,
.fade-slideshow-leave-to {
  opacity: 0;
}

/* ------------------------ */
.gallery-slideshow {
  position: absolute;
  width: var(--app-width);
  height: 305px;
}

/* ------------------------ */

/* ------------------------ */
</style>
